import { render, staticRenderFns } from "./product-details-children.vue?vue&type=template&id=54fd9725&scoped=true&"
import script from "./product-details-children.vue?vue&type=script&lang=js&"
export * from "./product-details-children.vue?vue&type=script&lang=js&"
import style0 from "./product-details-children.vue?vue&type=style&index=0&id=54fd9725&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fd9725",
  null
  
)

export default component.exports